module.exports = __webpack_public_path__ + "media/images/categories/icon_cat10-23a7ee055e2de5a7a8d375ac9b6ae01c.svg";